<script setup lang="ts">
import {NotificationTemplate} from "@/notification-template/interfaces";

defineProps<{
    template: NotificationTemplate
}>();
</script>

<template>
  <div class="flex flex-row py-2">
    <div class="flex items-center">
      <img src="@/assets/images/customer-app-logo.png" class="w-12 h-12" alt="app logo">
    </div>
    <div class="flex flex-1 flex-col bg-apodisPink rounded-lg p-4 ml-4">
      <span class="text-primary whitespace-pre-wrap">{{ template.parsed_content }}</span>
    </div>
  </div>
</template>
